export default "__VITE_ASSET__cf20447c__"